import { create } from 'zustand';
import i18n from 'i18n';
import { ApiUtils, MessagesApi } from '@shared/api';

interface UseDeleteMessagesThreadStore {
  loading: boolean;
  error?: string | null;
  success: boolean | null;
  delete: (threadId: string) => void;
  clear: () => void;
}

export const useDeleteMessagesThreadStore = create<UseDeleteMessagesThreadStore>((set) => ({
  loading: false,
  error: null,
  success: null,

  delete: async (threadId: string) => {
    try {
      set({ loading: true, error: null, success: null });
      MessagesApi.deleteMessagesThread(threadId);
      set({ loading: false, success: true });
      return { loading: false, success: true };
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, error, success: false });
      return { loading: false, error, success: false };
    }
  },

  clear: () => set({ loading: false, error: null, success: null }),
}));
